module.exports = require("core-js/library/fn/object/assign");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/assign.js
// module id = 1367
// module chunks = 0